import React from 'react';
import { parseRupiah } from '../../../hris/recruitment/utils/formatRupiah';

interface CurrencyInputProps {
  value: any;
  onChange?: (value: string) => void;
  readOnly?: boolean;
  className?: string;
  placeholder?: string;
}

export default function CurrencyInput({
  value,
  onChange,
  readOnly = false,
  className = '',
  placeholder = '0',
}: CurrencyInputProps) {
  // Format currency untuk input field
  const formatCurrencyInput = (val: any): string => {
    if (!val && val !== 0) return '';
    const numValue = typeof val === 'string' ? parseFloat(val.replace(/[^\d]/g, '')) : val;
    if (isNaN(numValue)) return '';
    return new Intl.NumberFormat('id-ID').format(numValue);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;
    const rawValue = parseRupiah(e.target.value);
    if (rawValue === '') {
      onChange('');
      return;
    }
    const numValue = parseFloat(rawValue);
    onChange(isNaN(numValue) ? '' : rawValue);
  };

  if (readOnly) {
    return (
      <input
        type="text"
        value={formatCurrencyInput(value)}
        readOnly
        className={`w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-right ${className}`}
        placeholder={placeholder}
      />
    );
  }

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">Rp</span>
      <input
        type="text"
        value={formatCurrencyInput(value)}
        onChange={handleChange}
        placeholder={placeholder}
        className={`w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200 text-right ${className}`}
      />
    </div>
  );
}
